import { Injectable } from '@angular/core';
import { TranslateService } from 'ng2-translate/ng2-translate';

import { StorageService } from '../storage/storage.service';

@Injectable()
export class TranslatorService {

    defaultLanguage: string = 'en';
    availablelangs: any;

    constructor(private translate: TranslateService, private storageService: StorageService) {
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang(this.defaultLanguage);

        this.availablelangs = [
            { code: 'en', text: 'English' },
            { code: 'es_ES', text: 'Español' }
        ];

        this.useLanguage(this.getCurrentLanguage());

    }

    useLanguage(lang: string = this.defaultLanguage) {
        this.translate.use(lang);
        this.storageService.setItem('lang', lang);
    }

    getAvailableLanguages() {
        return this.availablelangs;
    }

    getCurrentLanguage() {
        if (this.storageService.getItem('lang')) {
            return this.storageService.getItem('lang');
        }

        if (this.translate.currentLang) {
            return this.translate.currentLang;
        }

        return this.defaultLanguage;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/translator/translator.service.ts